module.exports = __webpack_public_path__ + "media/images/mobile_to_desktop-3a463fb61d88b58e267918e5fde80423.png";